<template>
	<div class="signin-prompt">
		<ProfilePic class="org-logo" :user="invite.organization" size="100px" />

		<i18n-t
			class="prompt"
			keypath="groupinvites_signup_join_org_label"
			tag="div"
			v-if="!isInternal"
		>
			<template #GroupName>
				<strong>{{ invite.group.title }}</strong>
			</template>
			<template #OrgName>
				<strong>{{ invite.organization.name }}</strong>
			</template>
		</i18n-t>

		<i18n-t
			class="prompt"
			keypath="groupinvites_org_member_required_full"
			tag="div"
			v-if="isInternal"
		>
			<template #OrgName>
				<strong v-text="invite.organization.name" />
			</template>
		</i18n-t>

		<div class="buttons">
			<Button large :to="toEmail">
				{{ $t('onboarding_loginmethod_email_button') }}
			</Button>
			<Button large :to="toPhone">
				{{ $t('onboarding_loginmethod_phone_button') }}
			</Button>
		</div>

		<Button
			link
			pronto
			href="https://support.pronto.io/en/articles/3273143-how-do-i-sign-into-pronto"
			newTab
		>
			{{ $t('onboarding_loginmethod_moreinfo_button') }}
		</Button>
	</div>
</template>

<script>
import { FormItem, Input, Button, ProfilePic } from '@/components/common'
import { emailRoute, phoneRoute, getInvite } from './index'
import { inviteAccessTypes } from '@/helpers/constants'

export default {
	components: { FormItem, Input, Button, ProfilePic },

	data() {
		return {
			invite: getInvite(),
		}
	},
	computed: {
		toEmail() {
			return { name: emailRoute.name, params: this.$route.params }
		},
		toPhone() {
			return { name: phoneRoute.name, params: this.$route.params }
		},
		isInternal() {
			return this.invite.access === inviteAccessTypes.INTERNAL
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.signin-prompt {
	@include flex-column-center;

	.org-logo {
		margin: 90px 0 16px 0;
	}

	.prompt {
		font-size: 18px;
		margin: 16px 0 56px 0;
		min-height: 100px;
		max-width: 330px;
		text-align: center;
		@include fontFamily(400);
		> strong {
			@include fontFamily(800);
		}
	}

	.buttons {
		margin-bottom: 36px;
		.pronto-btn:last-child {
			margin-left: 24px;
		}
	}
}
</style>
